// extracted by mini-css-extract-plugin
export default {"table":"O2j1eyAB0U2gOoMNJSIg","tr":"A7htdpR0Onc4pdTOqUgQ","td":"_DiARqDRVxE9Cv3J7OUB","placeHolderShimmer":"jBvHM_bZCfx9pKU0wnWr"};